import { createFileRoute } from '@tanstack/react-router'
import { AdminOrganizationUsagePage } from '@/components/pages/Admin/AdminOrganizationUsagePage/AdminOrganizationUsagePage.tsx'

export const Route = createFileRoute('/$workspaceName/$environment/admin/organizations/$id/usage')({
  component: AdminOrganizationUsageRoute,
})

function AdminOrganizationUsageRoute() {
  return <AdminOrganizationUsagePage />
}
